<div class="card">
  <div class="card-body">
    <h4><p style="color:#9b7544; overflow-wrap: break-word">

      This user is already register in our database.If you want to tag this user with you,
      click proceed.
    </p>
    
    </h4>
  </div>
  <div class="card-footer">
      <div class="row">
        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
         <button class="btn btn-success btn-block" (click)="closeDialog()">
           Proceed
         </button>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
           <button class="btn btn-syccess2 btn-block" mat-dialog-close>
               Cancel
           </button> 
       </div>
      </div>
    </div>
</div>
